<section class="form_section">
    <!--<div class="dialog-header">
      <button mat-icon-button (click)="cerrarDialogo()">
        <mat-icon>close</mat-icon>
      </button>
    </div>-->
    <h2>Actualizar Contraseña</h2>
    <form
    class="form_register_minutes"
    [formGroup]="form"
    (ngSubmit)="submit()"
  >
    <section class="container-form">
      <mat-form-field class="example-form-field">
        <mat-label>Nueva Contraseña</mat-label>
        <input matInput type="password" formControlName="newPass"/>
      </mat-form-field>
      <div *ngIf="form.controls['newPass'].errors?.['minlength']">
        <ng-container *ngIf="form.controls['newPass'].errors?.['minlength']">
          La contraseña debe tener al menos 8 caracteres.
        </ng-container>
      </div>
      <div *ngIf="form.controls['newPass'].errors?.['passwordStrength']">
        <ng-container *ngIf="form.controls['newPass'].errors?.['passwordStrength']">
          La contraseña debe contener al menos una letra mayúscula y un carácter especial.
        </ng-container>
      </div>
      <mat-form-field class="example-form-field">
        <mat-label>Repita Contraseña</mat-label>
        <input matInput type="password" formControlName="verifyNewPass"/>
      </mat-form-field>
      <div *ngIf="form.controls['verifyNewPass'].errors?.['minlength']">
        <ng-container *ngIf="form.controls['verifyNewPass'].errors?.['minlength']">
          La contraseña debe tener al menos 8 caracteres.
        </ng-container>
      </div>
      <div *ngIf="form.hasError('passwordMismatch')">
        <ng-container *ngIf="form.hasError('passwordMismatch')">
          Las contraseñas no coinciden.
        </ng-container>
      </div>
      <div *ngIf="form.controls['verifyNewPass'].errors?.['passwordStrength']">
        <ng-container *ngIf="form.controls['verifyNewPass'].errors?.['passwordStrength']">
          La contraseña debe contener al menos una letra mayúscula y un carácter especial.
        </ng-container>
      </div>
    </section>
    <section class="button_class">
      <button
        [disabled]="!form.valid"
        mat-stroked-button
        color="primary"
        type="submit"
        class="w-50"
      >
        Cambiar
      </button>
    </section>
  </form>
  
  </section>
  